<template>
    <div class="map" style="width: 100%; height: 300px;" tabindex="-1"></div>
</template>

<script>
import mapboxgl from "mapbox-gl";
import 'mapbox-gl/src/css/mapbox-gl.css';
import 'mapbox-gl/src/css/svg/mapboxgl-ctrl-compass.svg';
import 'mapbox-gl/src/css/svg/mapboxgl-ctrl-geolocate.svg';
import 'mapbox-gl/src/css/svg/mapboxgl-ctrl-zoom-in.svg';
import 'mapbox-gl/src/css/svg/mapboxgl-ctrl-zoom-out.svg';
import 'mapbox-gl/src/css/svg/mapboxgl-ctrl-fullscreen.svg';


export default {
    name: "LocationMap",
    props: ["locations", "selectedLocation"],
    data: function() {
        return {
            map: null,
            pos: [1.1,2.2],
        };
    },
    watch: {
        selectedLocation(loc) {
            console.log(loc)
            if (loc.id != 0) {
                //var map = this.$refs.map;
                this.zoom(10);
                this.panTo(loc.latLon.lat, loc.latLon.lon);
            }
            else{
                //this.getLocation(); FIXME this triggers browser location get, somehow broken logic
            }
        },
        locations() {
            //this.getLocation(); FIXME this triggers browser location get, somehow broken logic
        },
    },
    methods: {
        zoom: function(level) {
            this.map.setZoom(level);
        },
        panTo: function(lat, lon) {
            this.map.panTo([lon, lat]);
        },
        
        initialLocation (loc){
            console.log('INITIALLOCATION:::')
            if (loc.id != 0) {
                this.zoom(10);
                this.panTo(loc.latLon.lat, loc.latLon.lon);
            }
            else{
              //this.getLocation(); FIXME this triggers browser location get, somehow broken logic
            };
        },

        getLocation (){
            console.log('GETLOCATION:::');
            console.trace();
            if(navigator.geolocation){ 
                navigator.geolocation.getCurrentPosition(
                    pos => { 
                        this.zoom(10);
                        this.panTo(pos.coords.latitude, pos.coords.longitude);           
                    },
                    err => {
                        console.warn(`ERROR(${err.code}): ${err.message}`);
                        },
                    {
                        enableHighAccuracy: false,
                        timeout: 5000,
                        maximumAge: 0
                    }
                );     
            }
        },


        locationsFeatures: function() {

            var features = [];

            for (var i = 0; i < this.locations.length; i++) {
                if (this.locations[i].latLon.lat != 0 && this.locations[i].latLon.lon != 0) {
                    features.push({
                        type: "Feature",
                        geometry: {
                            type: "Point",
                            coordinates: [this.locations[i].latLon.lon, this.locations[i].latLon.lat],
                        },
                        properties: {
                            title: this.locations[i].name,
                            icon: "car-rental",
                        },
                    });
                }
            }
            return features;
        },

    },

    mounted: function() {
        var self = this;
    
        console.log(this.selectedLocation)
        mapboxgl.accessToken = "pk.eyJ1Ijoib2JpbHRzY2huaWciLCJhIjoiY2sxMDk5a3JnMDM5cjNvcWRzYWc4M3BoNCJ9.JdI1cYgzngezKcZlaZ83rg";
        
        
        this.map = new mapboxgl.Map({
            container: this.$el,
            style: "mapbox://styles/mapbox/streets-v11",
            center: [0.0,0.0],
            zoom: 3,
        });


        this.map.addControl(new mapboxgl.NavigationControl());
        this.map.addControl(new mapboxgl.FullscreenControl());

                    
        
        this.map.on("load", function() {
            

            self.map.loadImage(
                'https://img.icons8.com/color/48/000000/car-rental.png',
                function (error, image) {
                    if (error) throw error;
                    self.map.addImage('car', image);
                    self.map.addSource('point', {
                    'type': 'geojson',
                    'data': {
                    'type': 'FeatureCollection',
                    'features': self.locationsFeatures(),
                        }
                    })
                });

            self.map.addLayer({
                id: "points",
                type: "symbol",
                source: {
                    type: "geojson",
                    data: {
                        type: "FeatureCollection",
                        features: self.locationsFeatures(),
                    },
                },
                layout: {
                    "icon-image": "car",
                    "icon-size": 1,
                    "text-size": 25,
                    "text-field": "{title}",
                    "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
                    "text-offset": [0, 2],
                    "text-anchor": "top",
                },
                
            });
        });
    
        this.initialLocation(this.selectedLocation);
    },
};
</script>

<style lang="scss" scoped>
    .map{
        border: 1px solid rgba(32, 32, 32, 0.5);
    }
</style>
